import React, {Suspense} from 'react'
import Quantity from '@components/Money/Bags/Quantity'
import useWebsiteId from '@hooks/useWebsiteId'
import FormatNumber from '@i18n/formatNumber/Component'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

import {CheckoutV3GetBags, CheckoutV3GetBagsVariables} from './__generated__/CheckoutV3GetBags'
import renderLine from './helpers/renderLine'

function Bags() {
  const websiteId = useWebsiteId()
  const {data} = useQuery<CheckoutV3GetBags, CheckoutV3GetBagsVariables>({
    query: gql`
      query CheckoutV3GetBags($websiteId: ID!) {
        userPreferences(websiteId: $websiteId) {
          _id

          cart {
            deliveryType
            bagAmount
            calculatedBagsRequired
            maxBagsAllowed
          }

          bagsRequired
          websiteId
          deliveryType
        }
      }
    `,
    variables: {websiteId},
    fetchPolicy: 'cache-first'
  })

  const {userPreferences: preferences} = data
  const {
    cart: {bagAmount},
    deliveryType
  } = preferences

  if (!bagAmount) return null
  if (deliveryType !== 'go') return renderLine('Bolsas', <FormatNumber value={bagAmount} />)

  return renderLine(
    <div className="flex items-center">
      <Quantity
        bagsRequired={preferences.bagsRequired}
        calculatedBagsRequired={preferences.cart?.calculatedBagsRequired}
        maxBagsAllowed={preferences.cart?.maxBagsAllowed}
      />
      <span className="ml-1">Bolsas</span>
    </div>,
    <FormatNumber value={bagAmount} />
  )
}

export default function BagsWrapper() {
  return (
    <Suspense fallback={null}>
      <Bags />
    </Suspense>
  )
}
